/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgUploadCloud(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M8.677 2.257a8.75 8.75 0 018.628 5.992h.7a5.751 5.751 0 012.748 10.798.75.75 0 01-.718-1.317 4.25 4.25 0 00-2.031-7.981h-1.26a.75.75 0 01-.726-.563 7.25 7.25 0 10-12.452 6.616.75.75 0 01-1.124.993A8.75 8.75 0 018.677 2.257zm2.797 9.211a.75.75 0 011.06 0l4 3.999a.75.75 0 01-1.06 1.06l-2.72-2.718v7.19a.75.75 0 01-1.5 0v-7.19l-2.72 2.719a.75.75 0 11-1.06-1.061l4-3.999z'
      />
    </svg>
  );
}

export default SvgUploadCloud;
